import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function SecurityPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Security"
        description="JumpstoneAuth security practices. SOC 2 Type II certified, GDPR compliant, with enterprise-grade encryption and access controls."
        canonical="/security"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-white mb-4">Security</h1>
          <p className="text-lg text-surface-400">Enterprise-grade security you can trust</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

